module.exports = __webpack_public_path__ + "static/standalone/img/cancel-anytime.3f9a0674.svg";